import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class FabricOrdersProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_MER_API)
  }

  getAll (query) {
    this.setHeader(getAuthToken())
    return this.get('/fabric-orders', query)
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/fabric-orders/${id}`)
  }

  createOne (form) {
    this.setHeader(getAuthToken())
    return this.post('/fabric-orders', form)
  }

  updateOne (id, form) {
    this.setHeader(getAuthToken())
    return this.put(`/fabric-orders/${id}`, form)
  }

  deleteOne (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/fabric-orders/${id}`)
  }
}

export default FabricOrdersProvider
